import { module } from "angular";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type { IAlarm, IAlarmHandlingEvent, IResponse } from "../../Models";
import { AlarmEventSource, AlarmEventType } from "../../Models";
import type { IAlarmEventsRepository } from "./IAlarmEventsRepository";

export default class AlarmEventsRepository implements IAlarmEventsRepository {
    public static $inject: string[] = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getAlarmEvents(alarmId: string): Observable<IResponse<IAlarmHandlingEvent[]>> {
        return this.httpService.get<IAlarmHandlingEvent[]>(`alarms/${alarmId}/events`);
    }

    public post(alarmEventType: AlarmEventType, alarm: IAlarm): Observable<IResponse<void>> {
        const alarmEvent: IAlarmHandlingEvent = {
            alarmEventSource: AlarmEventSource[AlarmEventSource.MindCarePortal] as any,
            alarmEventType: AlarmEventType[alarmEventType] as any,
            alarmId: alarm.id,
            evaluation: alarm.alarmHandling.evaluation,
            measure: alarm.alarmHandling.measure,
            otherNotes: alarm.alarmHandling.otherNotes,
        };

        if (alarm.alarmHandling.alarmClassification) {
            alarmEvent.alarmClassification = alarm.alarmHandling.alarmClassificationName as any;
        }

        if (alarm.alarmHandling.totalSnoozeTime) {
            alarmEvent.totalSnoozeTime = alarm.alarmHandling.totalSnoozeTime.asMinutes();
        }

        return this.httpService.post<void>(`alarms/${alarmEvent.alarmId}/events`, alarmEvent);
    }
}

module("mmRepositories").service("mmAlarmEventsRepository", AlarmEventsRepository);
